import React, { useEffect } from 'react';
import { Dispatch,bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { dcrActionCreators } from '../store/DCRStore';
import { historyActionCreators } from '../store/HistoryStore';
import { AppState } from '../store/configureStore';
import Skeleton from "react-loading-skeleton";
import { cmsActionCreators } from '../store/CmsStore';
import { stateLoading } from '../functions/stateLoading';


type TCMRightMarginCMHistoryProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;
const RightMarginCMHistory = (props: TCMRightMarginCMHistoryProps) => {

    const cmsFormsLinksData = props.cmsData.fragments?.find(f => f.name === "FormsLinks");
    const cmsResourcesLinksData = props.cmsData.fragments?.find(f => f.name === "ResourcesLinks");
    const cmsResourcesLinksNonUploaderData = props.cmsData.fragments?.find(f => f.name === "ResourcesLinksNonUploader");

    useEffect(() => {
        if (stateLoading(props.cmsData)) {
            props.fetchCmsData();
        }
    });

    const isUploader = () => {
        return props.cmHistory?.cmHistoryInfo?.cntb_history?.org_type?.toUpperCase() === "U";
    }

    return (
        <>
                <div className="contribution-summary-panel mt-4 mt-sm-1">
                <h4 className="cont-summary-bottom-border">Resources</h4>
                    <div className="ml-3">
                    {
                        isUploader() 
                            ? cmsResourcesLinksData ? <span dangerouslySetInnerHTML={{ __html: cmsResourcesLinksData.html }} /> : <LoadingSkeleton />
                            : cmsResourcesLinksNonUploaderData ? <span dangerouslySetInnerHTML={{ __html: cmsResourcesLinksNonUploaderData.html }} /> : <LoadingSkeleton />
                    }
                    </div>
                </div>
                <div className="contribution-summary-panel mt-4 mt-sm-2">
                    <h4 className="cont-summary-bottom-border">Forms</h4>
                    <div className="ml-3">
                        {cmsFormsLinksData ? <span dangerouslySetInnerHTML={{ __html: cmsFormsLinksData.html }} /> : <LoadingSkeleton />}
                    </div>                        
                </div>
        </>
    )
};

function mapStateToProps(state: AppState) {
    return {
        dcr: state.dcr,
        cmHistory: state.cmHistory,
        cmsData: state.cms.manageContributions
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        ...dcrActionCreators,
        ...historyActionCreators,
        fetchCmsData: cmsActionCreators.fetchManageContributionsCmsData
    }, dispatch);
}

const LoadingSkeleton = () => (
    <div className="row ml-2">
        <div className="col-7 pl-0">
            <div className="mt-2"><Skeleton width={'17em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div className="mt-2"><Skeleton width={'17em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div><Skeleton width={'15em'} /></div>
            <div className="mt-2"><Skeleton width={'17em'} /></div>
        </div>
        <div className="col-4 pl-0"></div>
    </div>
);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RightMarginCMHistory);
